/**
 * Playwright Executable Stories
 *
 * BDD-style executable documentation for Playwright Test.
 *
 * @example
 * ```ts
 * import { test, expect } from '@playwright/test';
 * import { story } from 'executable-stories-playwright';
 *
 * test.describe('Calculator', () => {
 *   test('adds two numbers', async ({ page }, testInfo) => {
 *     story.init(testInfo);
 *
 *     story.given('two numbers 5 and 3');
 *     const a = 5;
 *     const b = 3;
 *
 *     story.when('I add them together');
 *     const result = a + b;
 *
 *     story.then('the result is 8');
 *     expect(result).toBe(8);
 *   });
 * });
 * ```
 */

// Story API
import { story } from './story-api';
export { story };
export type { Story } from './story-api';

// Top-level step helpers (framework contract)
export const given = story.given;
export const when = story.when;
export const then = story.then;
export const and = story.and;
export const but = story.but;

// Re-export types from local types module
export type {
  StoryMeta,
  StoryStep,
  DocEntry,
  StepKeyword,
  StoryDocs,
  StoryOptions,
  TicketInput,
  NormalizedTicket,
  KvOptions,
  JsonOptions,
  CodeOptions,
  TableOptions,
  LinkOptions,
  SectionOptions,
  MermaidOptions,
  ScreenshotOptions,
  VideoOptions,
  CustomOptions,
  ConsoleOptions,
  ObservePageErrorsOptions,
  AttachmentOptions,
} from './types';

// TestStepInfo re-exported from @playwright/test for consumer convenience
export type { TestStepInfo } from './step-runner';
